import {Navigate} from 'react-router-dom';
import {canViewInventoryPath} from '../../utils/inventoryNavigation.mjs';

export default function InventoryReviewGate({user,pathname,children}) {
  return canViewInventoryPath(user,pathname) ? children : <Navigate to="/dashboard" replace />;
}
